import React from 'react';
import { NikoTemplateInvoiceNoteModalTemplate } from 'themes/application/niko-patient/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { NikoTemplateInvoiceNoteModalStore } from 'application/niko-patient/stores';

@setCurrentView((rootStore, componentProps) => new NikoTemplateInvoiceNoteModalStore(rootStore, componentProps), 'nikoTemplateInvoiceNoteModalStore')
@observer
class NikoTemplateInvoiceNoteModal extends React.Component {
    render() {
        return <NikoTemplateInvoiceNoteModalTemplate {...this.props} />
    }
}

export default NikoTemplateInvoiceNoteModal;
